import Section, { SectionHeading } from "../ui/Section";
import { useApp } from "../../context/AppContext";
import { processSteps } from "../../data/content";

export default function Process() {
  const { t, locale } = useApp();

  return (
    <Section id="process" className="surface">
      <SectionHeading tag={t("process.tag")} title={t("process.title")} subtitle={t("process.subtitle")} />
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {processSteps.map((step, i) => (
          <div
            key={step.id}
            className="group relative overflow-hidden rounded-2xl border border-soft card-bg p-6 transition-all duration-300 hover:-translate-y-1 hover:border-cyan-400/40"
          >
            <span className="font-display text-4xl font-extrabold text-transparent [-webkit-text-stroke:1px_rgb(148_163_184_/_0.4)] transition-all group-hover:[-webkit-text-stroke:1px_rgb(34_211_238_/_0.7)]">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="mt-3 font-display text-lg font-bold">{step.title[locale]}</h3>
            <p className="mt-2 text-sm leading-relaxed text-soft">{step.description[locale]}</p>
          </div>
        ))}
      </div>
    </Section>
  );
}
